import { styled } from '@mui/material/styles'
import TableCell from '@mui/material/TableCell'

const NoWrapTableCell = styled(TableCell)(() => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 350
}))

export default NoWrapTableCell
